/**
 * The constructs a reader meets on a service's or function's own page,
 * taught once (stitching review 5.5). Round 16 found "MVB" unexplained
 * on the chip for the tenth round, the group chip naming a group without
 * saying what one is, and a treasurer's page using his class, funding
 * and integrity with no definition of any.
 *
 * Which terms depend on what the page shows: a function's page teaches
 * the function's constructs, a service's teaches MVB and its group only
 * where it carries them.
 */
import { FirstMeetings } from "shared/glossary/FirstMeetings";
import { useIBSStory } from "twin/api/hooks";

export function IBSFirstMeetings({ ibsId }: { ibsId: string | undefined }) {
  const story = useIBSStory(ibsId);
  const s = story.data;
  if (!s) return null;
  const terms =
    s.service_class === "internal"
      ? ["critical_internal_function", "funding_edge", "integrity_tolerance"]
      : [
          "ibs",
          ...(s.mvb?.flag ? ["mvb"] : []),
          ...(s.group_name ? ["ibs_group"] : []),
          "impact_tolerance",
        ];
  return <FirstMeetings terms={terms} className="mt-3" />;
}
